"use client";

import createIcon from './util/createIcon';
export default createIcon('M21 8H3V6H21V8M13.81 16H10V18H13.09C13.21 17.28 13.46 16.61 13.81 16M18 11H6V13H18V11M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z', 'FilterVariantPlus');